module.exports = __webpack_public_path__ + "0af5d249/img/lock-icon.bb9c7166.svg";